import makeStyles from '@mui/styles/makeStyles'

const useDeemedReportStyles = makeStyles({
  root: {},
  headtext: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
})

export default useDeemedReportStyles
